const tokenName = "token";

const isAuthorized = props => {
  return localStorage.getItem(tokenName) && Object.keys(props.user).length > 0;
};

const saveToken = token => localStorage.setItem(tokenName, token);

const getToken = () => {
  return localStorage.getItem(tokenName);
};

const deleteToken = () => localStorage.removeItem(tokenName);

// Session management utilities
const generateTimestamp = () => {
  return Date.now().toString();
};

const clearAllAuthData = () => {
  // Clear localStorage items that might contain tenant-specific data
  // Note: Theme preferences (isDarkEnabled, colorScheme) are preserved across sessions
  const itemsToRemove = [
    tokenName,
    "user_email",
    "onelogin_user_email",
    "azure_user_email",
    "onelogin_url",
    "onelogin_client_id",
    "azure_tenant_id",
    "azure_client_id",
    "azure_client_secret",
    "languages",
    "date_format",
    "date_time_format",
    "notification_days",
    "tenantTrial",
    "persist:root", // Redux persist data
  ];

  itemsToRemove.forEach(item => {
    localStorage.removeItem(item);
  });

  // Clear session storage as well
  sessionStorage.clear();

  // Clear any redux-persist cache
  if (window.localStorage.getItem('persist:root')) {
    window.localStorage.removeItem('persist:root');
  }
};

const clearBrowserCache = () => {
  // Add freshness timestamp to prevent browser from serving stale responses
  const timestamp = generateTimestamp();
  
  // Set cache control headers for future requests
  window.freshTimestamp = timestamp;
  
  // Force reload of critical cached resources if needed
  // This is useful for development but be careful in production
  if (process.env.NODE_ENV === 'development') {
    // You can uncomment this if you need aggressive cache busting in development
    // window.location.reload(true);
  }
};

const clearAllCache = () => {
  // Clear all authentication related data
  clearAllAuthData();
  
  // Clear browser cache
  clearBrowserCache();
  
  // Clear any service worker cache if present
  if ('serviceWorker' in navigator && 'caches' in window) {
    caches.keys().then(function(cacheNames) {
      return Promise.all(
        cacheNames.map(function(cacheName) {
          return caches.delete(cacheName);
        })
      );
    });
  }
};

const makeUrlFresh = (url) => {
  const timestamp = window.freshTimestamp || generateTimestamp();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_fresh=${timestamp}`;
};

export default {
  isAuthorized,
  saveToken,
  getToken,
  deleteToken,
  generateTimestamp,
  clearAllAuthData,
  clearBrowserCache,
  clearAllCache,
  makeUrlFresh
};